import { render, staticRenderFns } from "./Forgot.vue?vue&type=template&id=6bf5620c"
import script from "./Forgot.js?vue&type=script&lang=js&external"
export * from "./Forgot.js?vue&type=script&lang=js&external"
import style0 from "./Forgot.vue?vue&type=style&index=0&id=6bf5620c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports